import React from 'react';
import { motion } from 'framer-motion';
import InputSection from './InputSection';
import CurrencyInput from './CurrencyInput';
import SelectInput from './SelectInput';
import ReferralFeeInput from './ReferralFeeInput';

const InputForm = ({ formData, onInputChange }) => {
  const fixedCostsFields = [
    { key: 'employeeCosts', label: 'Employee costs', placeholder: '0.00' },
    { key: 'materials', label: 'Materials (printing, postage)', placeholder: '0.00' },
    { key: 'subcontractors', label: 'Subcontractors (designer, VA)', placeholder: '0.00' },
    { key: 'otherFixedCosts', label: 'Other fixed costs (software subscriptions)', placeholder: '0.00' }
  ];

  const variableCostsFields = [
    { key: 'projectAdmin', label: 'Project admin support', placeholder: '0.00' },
    { key: 'otherVariableCosts', label: 'Other variable costs (travel, venue)', placeholder: '0.00' }
  ];

  const contingencyOptions = [
    { value: '10', label: '10%' },
    { value: '15', label: '15%' },
    { value: '20', label: '20%' }
  ];

  return (
    <div className="space-y-8">
      {/* Fixed Costs */}
      <InputSection title="Fixed Costs">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {fixedCostsFields.map((field) => (
            <CurrencyInput
              key={field.key}
              label={field.label}
              value={formData[field.key]}
              onChange={(value) => onInputChange(field.key, value)}
              placeholder={field.placeholder}
            />
          ))}
        </div>
      </InputSection>

      {/* Variable Costs */}
      <InputSection title="Variable Costs">
        <div className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <CurrencyInput
              label="Consultant hours"
              value={formData.consultantHours}
              onChange={(value) => onInputChange('consultantHours', value)}
              placeholder="0"
              prefix=""
              suffix=" hrs"
            />
            <CurrencyInput
              label="Hourly rate"
              value={formData.hourlyRate}
              onChange={(value) => onInputChange('hourlyRate', value)}
              placeholder="0.00"
            />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {variableCostsFields.map((field) => (
              <CurrencyInput
                key={field.key}
                label={field.label}
                value={formData[field.key]}
                onChange={(value) => onInputChange(field.key, value)}
                placeholder={field.placeholder}
              />
            ))}
          </div>
        </div>
      </InputSection>

      {/* Other Inputs */}
      <InputSection title="Package Details">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <CurrencyInput
            label="Package price (including GST)"
            value={formData.packagePrice}
            onChange={(value) => onInputChange('packagePrice', value)}
            placeholder="0.00"
          />
          
          <ReferralFeeInput
            referralFeeType={formData.referralFeeType || 'amount'}
            referralFeeValue={formData.referralFeeValue || ''}
            onReferralFeeTypeChange={(value) => onInputChange('referralFeeType', value)}
            onReferralFeeValueChange={(value) => onInputChange('referralFeeValue', value)}
          />
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          <SelectInput
            label="Contingency buffer"
            value={formData.contingencyBuffer}
            onChange={(value) => onInputChange('contingencyBuffer', value)}
            options={contingencyOptions}
          />
          <CurrencyInput
            label="Income tax rate"
            value={formData.incomeTaxRate}
            onChange={(value) => onInputChange('incomeTaxRate', value)}
            placeholder="30"
            prefix=""
            suffix="%"
          />
        </div>
      </InputSection>
    </div>
  );
};

export default InputForm;